import { render } from "./CalendarEventAttendeesListItem.vue?vue&type=template&id=bd58e8a8&scoped=true"
import script from "./CalendarEventAttendeesListItem.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeesListItem.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendeesListItem.vue?vue&type=style&index=0&id=bd58e8a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bd58e8a8"

export default script